import React from 'react';

/**
 * Unified LoadingSpinner component for consistent loading states across the application
 * @param {string} message - Optional loading message text (default: "Loading content...")
 * @param {string} bgColor - Optional background color (default: "bg-white")
 * @param {string} spinnerColor - Optional spinner color class (default: "border-[#73ab40]")
 * @param {number} py - Optional padding Y (default: 24, represents py-24)
 */
export default function LoadingSpinner({ 
  message = "Loading content...", 
  bgColor = "bg-white",
  spinnerColor = "border-[#73ab40]",
  py = 24
}) {
  const paddingClass = `py-${py}`;
  
  return (
    <div className={`${paddingClass} ${bgColor} flex items-center justify-center`}>
      <div className="text-center">
        <div className={`animate-spin rounded-full h-12 w-12 ${spinnerColor} border-b-2 mx-auto mb-4`}></div>
        <p className="text-slate-600">{message}</p>
      </div>
    </div>
  );
}
